import { ExamCenterProctorType } from '@exam-center/graphql';

import { BANGKOK_PROVINCE_CODE } from '../../constants';

export function mapProctorsCountByTypeData(proctorsCount: Record<ExamCenterProctorType, number>) {
  const proctorsCountByType = Object.entries(proctorsCount).reduce<
    Record<ExamCenterProctorType, number>
  >(
    (acc, [type, count]) => {
      acc[type as ExamCenterProctorType] += count;
      return acc;
    },
    {
      [ExamCenterProctorType.Proctor_1]: 0,
      [ExamCenterProctorType.Proctor_2]: 0,
      [ExamCenterProctorType.Proctor_3]: 0,
    },
  );

  const totalProctorsCount = Object.values(proctorsCountByType).reduce<number>(
    (acc, curr) => acc + curr,
    0,
  );

  return { proctorsCountByType, totalProctorsCount };
}

export function mapExamCenterRoomsCountByProvinceData(
  examCenterRoomsCountByProvince: Record<string, number>,
) {
  const bangkokAndOtherProvinceRoomsCount = Object.entries(examCenterRoomsCountByProvince).reduce<
    Record<string, number>
  >(
    (acc, [provinceCode, count]) => {
      if (provinceCode === BANGKOK_PROVINCE_CODE) {
        acc.bangkok += count;
      } else {
        acc.other += count;
      }
      return acc;
    },
    {
      bangkok: 0,
      other: 0,
    },
  );

  const totalRoomsCount = Object.values(bangkokAndOtherProvinceRoomsCount).reduce<number>(
    (acc, curr) => acc + curr,
    0,
  );

  return { bangkokAndOtherProvinceRoomsCount, totalRoomsCount };
}
